import React, { useRef, useEffect, Fragment, useContext, useState } from 'react';
import { gsap } from 'gsap';
import './Statistics.scss';
import { WidthContext } from '../../WidthContext';

function Statistics1() {
  const width = useContext(WidthContext);
  const [current, setCurrent] = useState('rate');
  const container = useRef();
  const barRef0 = useRef();
  const barRef1 = useRef();
  const barRef2 = useRef();
  const barRef3 = useRef();
  const barRef4 = useRef();
  const barRef5 = useRef();
  const barRef6 = useRef();
  const barRef7 = useRef();
  const barRef8 = useRef();
  const barRef9 = useRef();
  const barRef10 = useRef();
  const barRef11 = useRef();

  const barRefs = useRef();
  const dataRefs = useRef();

  barRefs.current = [
    barRef0,
    barRef1,
    barRef2,
    barRef3,
    barRef4,
    barRef5,
    barRef6,
    barRef7,
    barRef8,
    barRef9,
    barRef10,
    barRef11
  ];

  dataRefs.current = {
    rate: [2.9, 3, 2.9, 3.1, 3.8, 5.2, 5.6, 6.7, 6.1, 5.7, 5.6, 5.5],
    sales: [6.29, 5.95, 6.07, '6.20', 6.06, 5.37, 4.77, '4.90', '5.00', 5.37, 5.51, 5.66],
    period: [
      '‘21 Q1',
      '‘21 Q2',
      '‘21 Q3',
      '‘21 Q4',
      '‘22 Q1',
      '‘22 Q2',
      '‘22 Q3',
      '‘22 Q4',
      '‘23 Q1',
      '‘23 Q2',
      '‘23 Q3',
      '‘23 Q4'
    ]
  };

  useEffect(() => {
    barRefs.current.forEach((ref, i) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: 'top 75%',
          end: 'top 75%',
          once: true
        }
      });

      tl.to(ref.current, {
        height: width > 767 ? `${(dataRefs.current[current][i] / 8) * 100}%` : null,
        width: width < 768 ? `${(dataRefs.current[current][i] / 8) * 100}%` : null,
        duration: 1.2
      }).to('.bar-number-1', { opacity: 1, duration: 0.7, ease: 'ease-in' }, '-=0.5');
    });
  }, [current, width]);

  return (
    <figure className="statistics">
      <div className="statistics__graphic" ref={container}>
        <h3 className="statistics__graphic__title statistics__graphic__title-1">
          NAR 2023 FORECAST
        </h3>
        <p className="statistics__graphic__copy">
          NAR's chief economist sees mortgage rates drifting lower, and home sales stabilizing and
          then starting to climb.
        </p>
        <div className="statistics__graphic__buttons">
          <button
            className={
              current === 'rate'
                ? 'statistics__graphic__button buttons--round--active'
                : 'statistics__graphic__button buttonClick'
            }
            id="mortgageRateForecast"
            onClick={() => {
              setCurrent('rate');
            }}
          >
            MORTGAGE RATE FORECAST
          </button>
          <button
            className={
              current === 'sales'
                ? 'statistics__graphic__button buttons--round--active'
                : 'statistics__graphic__button buttonClick'
            }
            id="homeSalesForecast"
            onClick={() => {
              setCurrent('sales');
            }}
          >
            HOME SALES FORECAST
          </button>
        </div>
        <div className="statistics__graphic-container">
          <div className="statistics__graphic__graph statistics__graphic__graph-1">
            <div className="statistics__graphic__graph__range">
              {[...Array(9)].map((num, i) => (
                <span key={i}>
                  {8 - i}
                  {current === 'rate' ? '%' : i !== 8 ? 'M' : ''}
                </span>
              ))}
            </div>
            {dataRefs.current[current].map((el, i) => {
              return (
                <Fragment key={`${el}-${i}`}>
                  <div className="bar bar-1">
                    <div className="bar-container bar-container-1">
                      {current === 'rate' ? (
                        <span
                          className={
                            !dataRefs.current[current][i + 4]
                              ? 'bar-number bar-number-1  bar-number-1--last '
                              : 'bar-number bar-number-1'
                          }
                        >
                          {el}%
                        </span>
                      ) : (
                        <span
                          className={
                            !dataRefs.current[current][i + 4]
                              ? 'bar-number bar-number-1 bar-number-1--last bar-number--sales'
                              : 'bar-number bar-number-1  bar-number--sales'
                          }
                        >
                          {el}M
                        </span>
                      )}

                      <div
                        className={
                          !dataRefs.current[current][i + 4]
                            ? 'bar-left bar-left-1 bar-left-1--last'
                            : 'bar-left bar-left-1'
                        }
                        ref={barRefs.current[i]}
                      />
                    </div>
                  </div>
                </Fragment>
              );
            })}
          </div>
          <div className="statistics__graphic__label statistics__graphic__label-1">
            {dataRefs.current.period.map((el, i) => (
              <span className="statistics__graphic__label-1__text" key={i}>
                {el}
              </span>
            ))}
          </div>
        </div>
        <div className="statistics__graphic__keys">
          <div className="statistics__graphic__key">
            <span className="statistics__graphic__key__color statistics__graphic__key__color-blue" />
            <span className="statistics__graphic__key__text">Historical Data</span>
          </div>
          <div className="statistics__graphic__key">
            <span className="statistics__graphic__key__color statistics__graphic__key__color-red" />
            <span className="statistics__graphic__key__text">NAR Forecast</span>
          </div>
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Statistics1;
